import { breadcrumbsControlTypes, Actions } from "~/types/breadcrumbsControl";
import { ReduxState } from "~/types/redux";
import assign from "lodash/assign";

const breadcrumbsControl = (state: ReduxState, action: Actions): ReduxState => {
  switch (action.type) {
    case breadcrumbsControlTypes.SET_ACCORDION_STEP:
      return assign({}, state, {
        breadcrumbsControl: {
          ...state.breadcrumbsControl,
          accordionStep: action.accordionStep,
        },
      });
    case breadcrumbsControlTypes.SET_STEP_CHANGE_TO:
      return assign({}, state, {
        breadcrumbsControl: {
          ...state.breadcrumbsControl,
          stepChangeTo: action.stepChangeTo,
        },
      });
    default:
      return state;
  }
};

export default breadcrumbsControl;
